import { IAppState } from '../../../../store/state/app.state';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { NgForm, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import * as UserActions from '../../../../store/user/actions/user.actions';
import { UtilitiesFacades } from '../../../../store/utilities/facades/utilities.facades';
import { Country } from '../../../../models/country';
import { UserFacade } from '../../../../store/user/facade/user.facade';
import { getUserState } from './../../../../store/user/selectors/user.selectors';
import { IUserState } from './../../../../store/state/user.state';
import { AccountVM } from '../../../../models/account';
import { IInvestorDetails } from '../../../../models/registration/investorDetails';
import { IUserAddress } from '../../../../models/userAddress';
import { onlyDigitsPattern } from '../../../../utils/only-digits-pattern';

@Component({
  selector: "app-address",
  templateUrl: "./address-details.component.html",
  styleUrls: ["./address-details.component.scss"]
})
export class AddressDetailsComponent implements OnInit, OnDestroy {

  @ViewChild('f') form: NgForm;
  public countryList: any[];
  public addressForm = new UntypedFormGroup({
    streetName: new UntypedFormControl(null, [Validators.required]),
    streetNumber: new UntypedFormControl(null, [Validators.required]),
    suburb: new UntypedFormControl(null),
    city: new UntypedFormControl(null, [Validators.required]),
    postcode: new UntypedFormControl(null, [Validators.pattern(onlyDigitsPattern)]),
    countryAlpha2: new UntypedFormControl(null, [Validators.required]),
    setAddressToIndividualAccounts: new UntypedFormControl(null),
  });
  countryListSubscription: Subscription;
  public country: string;
  userState: IUserState;
  userEntityId: string;
  userSubscription: Subscription;
  userAddressSubscription: Subscription;
  userProfile: AccountVM;
  failText: string;
  successText: string;
  loading = false;
  showSpinner = false;
  userAddressUpdatedSuccess = false;
  showFormUpdatedSuccess = false;
  investorDetails: IInvestorDetails;
  userAddress: IUserAddress;

  constructor(
    private store: Store<IAppState>,
    private router: Router,
    private utilitiesFacade: UtilitiesFacades,
    private userFacade: UserFacade,
  ) {
  }

  ngOnInit() {
    this.userAddressSubscription = this.userFacade.getUserAddress().subscribe((userAddressData: IUserAddress) => {
      if (userAddressData) {
        this.userAddress = userAddressData;
      }
    });
    this.countryListSubscription = this.utilitiesFacade.getCountryList().subscribe((countryList: Country[]) => {
      this.countryList = countryList;
    });

    this.userSubscription = this.store.pipe(select(getUserState))
      .subscribe((state: IUserState) => {
        if (!state.viewProfile) {
          return;
        }
        this.userState = state;
        this.userAddressUpdatedSuccess = this.userState.viewProfile.profileUpdatedSuccess;
        this.loading = this.userState.viewProfile.loading;
        this.failText = this.userState.viewProfile.failText;
        this.successText = this.userState.viewProfile.successText;
        this.showSpinner = this.loading;
        if (!this.userAddressUpdatedSuccess) {
          this.patchFormValues();
        };
        this.showFormUpdatedSuccess = (this.userAddressUpdatedSuccess && !this.loading);
      });
  }

  onSubmit(form: NgForm) {
    const updateUserAddress: IUserAddress = {
      streetNumber: this.addressForm.value.streetNumber,
      streetName: this.addressForm.value.streetName,
      suburb: this.addressForm.value.suburb,
      city: this.addressForm.value.city,
      postcode: this.addressForm.value.postcode,
      countryAlpha2: this.addressForm.value.countryAlpha2,
      setAddressToIndividualAccounts: this.addressForm.value.setAddressToIndividualAccounts
    };
    this.userFacade.setUserAddress(updateUserAddress);
  }

  private patchFormValues() {
    this.addressForm.patchValue(this.userAddress);
  }

  onResetAndClose() {
    this.patchFormValues();
    setTimeout(() => {
      this.router.navigate([{ outlets: { sidebar: null } }]);
    }, 300);
    this.store.dispatch(new UserActions.UserProfileEditClose());
  }

  ngOnDestroy() {
    this.countryListSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
    this.userAddressSubscription.unsubscribe();
    this.store.dispatch(new UserActions.ResetUserProfileForm());
  }

}
